import React from "react";
import { LoginPage } from "@d-m-organization/hub-shared-lib/auth";
import { HubLayout } from "../components/HubLayout.js";

export function LoginRoute() {
  return (
    <LoginPage
      wrapper={HubLayout}
      signupPath="/signup"
      ns="common"
    />
  );
}
